<template>
  <v-card :loading="$store.getters.GET_LOADING"
          tile :min-height="$vuetify.breakpoint.height / 3">
    <v-card-title>
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <span>{{$t('admin.dashboard.requests')}}</span>
          <v-spacer/>
        </v-col>
        <v-col cols="12" class="d-flex">
          <v-select :label="visitInfo.label"
                    v-model="date"
                    item-value="value"
                    :placeholder="visitInfo.placeholder"
                    @change="getVisits"
                    :items="visits"></v-select>
          <v-spacer/>
          <v-select :label="exportInfo.label"
                    v-model="period"
                    item-value="value"
                    :placeholder="exportInfo.placeholder"
                    :items="exports"></v-select>
          <template v-if="period">
            <v-spacer/>
            <v-btn text @click="exportVisits">
              {{ $t('admin.export.button') }}
            </v-btn>
          </template>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div v-show="!$store.getters.GET_LOADING && siteVisits.length > 0"
           id="visits"
           :style="`min-height: ${$vuetify.breakpoint.height / 3.4}px`"></div>
      <template v-if="!$store.getters.GET_LOADING && siteVisits.length === 0">
        <div class="d-flex align-center justify-center">
          <span class="text-h4">{{ $t('notAvailable') }}</span>
        </div>
      </template>
    </v-card-text>
    <v-snackbar tile timeout="-1" v-model="snackbar" top color="accent">
      <validation-observer ref="observer">
        <validation-provider :name="exportInfo.name" rules="required|integer" v-slot="{ errors }">
          <v-text-field type="number" :error-messages="errors" :label="exportInfo.label"
                        :placeholder="exportInfo.placeholderCustom"
                        v-model="custom"></v-text-field>
        </validation-provider>
      </validation-observer>
      <template v-slot:action="{ attrs }">
        <v-btn
          tile
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
        <v-btn
          tile
          color="deep-purple lighten-4"
          text
          v-bind="attrs"
          @click="exportVisits"
        >
          {{ $t('admin.export.button') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
/* eslint-disable no-unused-vars, camelcase */

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_material from '@amcharts/amcharts4/themes/material'
import am4lang_en_US from '@amcharts/amcharts4/lang/en_US'
import am4lang_de_DE from '@amcharts/amcharts4/lang/de_DE'
export default {
  name: 'VisitsInfoV2Component',
  data () {
    return {
      snackbar: false,
      value: [],
      period: null,
      custom: null,
      date: 7,
      lang: this.$store.getters.GET_LANG,
      link: process.env.NODE_ENV === 'production' ? `${process.env.VUE_APP_API_URL}/public/storage/` : `${process.env.VUE_APP_API_URL}/storage/`
    }
  },
  watch: {
    period: function () {
      this.period === 0 ? this.snackbar = true : this.snackbar = false
    }
  },
  mounted () {
    this.$root.$on('change-locale', () => {
      this.getVisits()
    })
    this.$root.$on('build-stats', () => {
      this.buildChart(this.$store.getters.GET_STATISTIC.visits)
    })
  },
  methods: {
    async getVisits () {
      await this.$http.get(`api/v2/auth/regions/grouped/${this.date}`)
        .then(response => {
          this.$store.dispatch('setStatistic', response.data)
            .then(() => {
              this.$root.$emit('build-stats')
            })
            .finally(() => {
              this.$store.dispatch('setLoading', false)
            })
        })
    },
    exportVisits () {
      this.$refs.observer.validate()
      this.$store.dispatch('setLoading', true)
      this.$http.get(`api/v2/auth/region/export/${this.period !== 0 ? this.period : this.custom}`)
        .then(response => {
          this.link += response.data.link
          window.open(this.link, '_blank')
          this.link = process.env.NODE_ENV === 'production' ? `${process.env.VUE_APP_API_URL}/public/storage/` : `${process.env.VUE_APP_API_URL}/storage/`
          this.period = null
          this.custom = null
          this.snackbar = false
        })
        .finally(() => {
          this.$store.dispatch('setLoading', false)
        })
    },
    buildChart (data) {
      am4core.options.autoDispose = true
      am4core.options.queue = true
      am4core.useTheme(am4themes_material)
      const chart = am4core.create('visits', am4charts.XYChart)
      chart.data = data
      chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd'

      const dateAxis = chart.xAxes.push(new am4charts.DateAxis())
      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis())

      const series = chart.series.push(new am4charts.LineSeries())
      series.dataFields.valueY = 'count'
      series.dataFields.dateX = 'date'
      series.tooltipText = '{count}'
      series.strokeWidth = 2
      series.stroke = am4core.color('#233347')
      series.fill = am4core.color('#233347')
      series.backgroundColor = '#233347'
      series.minBulletDistance = 20

      series.tooltip.background.cornerRadius = 20
      series.tooltip.pointerOrientation = 'vertical'
      series.tooltip.label.minWidth = 40
      series.tooltip.label.minHeight = 40
      series.tooltip.label.textAlign = 'middle'

      const bullet = series.bullets.push(new am4charts.CircleBullet())
      bullet.circle.strokeWidth = 2
      bullet.circle.radius = 4
      bullet.circle.fill = am4core.color('#fff')

      const bullethover = bullet.states.create('hover')
      bullethover.properties.scale = 1.3

      chart.cursor = new am4charts.XYCursor()
      chart.cursor.behavior = 'panXY'
      chart.cursor.xAxis = dateAxis
      chart.cursor.snapToSeries = series

      chart.scrollbarY = new am4core.Scrollbar()
      chart.scrollbarY.parent = chart.leftAxesContainer
      chart.scrollbarY.toBack()

      chart.scrollbarX = new am4charts.XYChartScrollbar()
      chart.scrollbarX.series.push(series)
      chart.scrollbarX.parent = chart.bottomAxesContainer

      dateAxis.start = 0
      dateAxis.keepSelection = true
      switch (this.$store.getters.GET_LANG) {
      case 'en':
        chart.language.locale = am4lang_en_US
        chart.dateFormatter.language = new am4core.Language()
        chart.dateFormatter.language.locale = am4lang_en_US
        break
      case 'de':
        chart.language.locale = am4lang_de_DE
        chart.dateFormatter.language = new am4core.Language()
        chart.dateFormatter.language.locale = am4lang_de_DE
        break
      }
    }
  },
  computed: {
    exports () {
      return this.$t('admin.dashboard.exports')
    },
    visits () {
      return this.$t('admin.dashboard.visits')
    },
    websites () {
      return this.$t('admin.dashboard.websites')
    },
    exportInfo () {
      return this.$t('admin.dashboard.export')
    },
    visitInfo () {
      return this.$t('admin.dashboard.visit')
    },
    siteVisits () {
      return this.$store.getters.GET_STATISTIC.visits ? this.$store.getters.GET_STATISTIC.visits : []
    }
  }
}
</script>

<style scoped>

</style>
